export default [
  {
    path: "/jghdetail",
    name: "jghdetail",
    component: (resolve) => require(["@/views/PCView/jgh/JghDetail.vue"], resolve),
    // redirect: "/jghdetail/jghblog",
    // children: [
    //   {
    //     path: "/jghdetail/jghmain",
    //     name: "jghmain",
    //     component: (resolve) => require(["@/views/jgh/view/Main.vue"], resolve),
    //   },
    //   {
    //     path: "/jghdetail/jghblog",
    //     name: "jghblog",
    //     component: (resolve) => require(["@/views/jgh/view/Blog.vue"], resolve),
    //   },
    //   {
    //     path: "/jghdetail/jghvideo",
    //     name: "jghvideo",
    //     component: (resolve) =>
    //       require(["@/views/jgh/view/JghVideo.vue"], resolve),
    //   },
    //   {
    //     path: "/jghdetail/jghmonograph",
    //     name: "jghmonograph",
    //     component: (resolve) =>
    //       require(["@/views/jgh/view/JghMonograph.vue"], resolve),
    //   },
    //   {
    //     path: "/jghdetail/jghpaper",
    //     name: "jghpaper",
    //     component: (resolve) =>
    //       require(["@/views/jgh/view/Paper.vue"], resolve),
    //   },
    //   {
    //     path: "/jghdetail/jghhybg",
    //     name: "jghhybg",
    //     component: (resolve) => require(["@/views/jgh/view/Hybg.vue"], resolve),
    //   },
    // ],
  },
];
